// extracted by mini-css-extract-plugin
export default {"col":"styles_col__CGwux","formContainer":"styles_formContainer__2KO+C","form":"styles_form__ixcJ9"};